<template>
  <div class="report-page">
    <!-- 头部 -->
    <div class="report-header">
      <div class="header-back" @click="$router.go(-1)">
        <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="none" stroke="#fff" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="header-title">{{ tabs[reportCurrent - 1] }}</div>
    </div>

    <!-- 选项卡 -->
    <div class="report-tabs">
      <div class="tabs-wrap">
        <div
          v-for="(tab, idx) in tabs"
          :key="idx"
          class="tab-item"
          :class="{ active: reportCurrent === idx + 1 }"
          @click="switchTab(idx + 1)"
        >{{ tab }}</div>
      </div>
    </div>

    <!-- 账户明细 -->
    <div class="tab-content" v-if="reportCurrent === 1">
      <div class="balance-row">
        <div class="balance-left">
          <span class="balance-label">当前余额</span>
          <span class="balance-num">{{ $store.state.userInfo.balance }}</span>
          <svg class="refresh-icon" @click="refreshBalance" viewBox="0 0 24 24" width="0.45rem" height="0.45rem" fill="none" stroke="#d1ae52" stroke-width="3">
            <path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
          </svg>
        </div>
        <div class="balance-right" @click="switchTab(4)">
          <span>找回丢失余额</span>
          <svg viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="none" stroke="#d1ae52" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </div>
      <div class="balance-tip">
        <svg viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="#999">
          <circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01" stroke="#999" stroke-width="2" fill="none"/>
        </svg>
        <span>若进出游戏时余额丢失的，可通过找回余额自助恢复。</span>
      </div>

      <!-- 筛选 -->
      <div class="filter-row">
        <div class="filter-item" @click="showDatePopup = !showDatePopup; showCatePopup = false">
          <span>{{ {today:'今日',yesterday:'昨日',week:'本周',last_week:'上周',month:'本月',last_month:'上月',all:'全部'}[accountDateType] }}</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" stroke="#999" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <div class="filter-item" @click="showCatePopup = !showCatePopup; showDatePopup = false">
          <span>{{ accountCateType === '' ? '账变大类' : {0:'转入转出',3:'后台加款',4:'后台扣款',5:'红包'}[accountCateType] }}</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" stroke="#999" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <div class="filter-item">
          <span>小类明细</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" stroke="#999" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
      </div>

      <!-- 日期筛选弹窗 -->
      <div class="filter-popup" v-if="showDatePopup">
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: accountDateType === 'today' }" @click="onDateFilter('today'); showDatePopup = false">今日</div>
          <div class="popup-btn" :class="{ active: accountDateType === 'yesterday' }" @click="onDateFilter('yesterday'); showDatePopup = false">昨日</div>
          <div class="popup-btn" :class="{ active: accountDateType === 'week' }" @click="onDateFilter('week'); showDatePopup = false">本周</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: accountDateType === 'last_week' }" @click="onDateFilter('last_week'); showDatePopup = false">上周</div>
          <div class="popup-btn" :class="{ active: accountDateType === 'month' }" @click="onDateFilter('month'); showDatePopup = false">本月</div>
          <div class="popup-btn" :class="{ active: accountDateType === 'last_month' }" @click="onDateFilter('last_month'); showDatePopup = false">上月</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: accountDateType === 'all' }" @click="onDateFilter('all'); showDatePopup = false">全部</div>
        </div>
      </div>

      <!-- 大类筛选弹窗 -->
      <div class="filter-popup" v-if="showCatePopup">
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: accountCateType === '' }" @click="onCateFilter(''); showCatePopup = false">全部</div>
          <div class="popup-btn" :class="{ active: accountCateType === 0 }" @click="onCateFilter(0); showCatePopup = false">转入转出</div>
          <div class="popup-btn" :class="{ active: accountCateType === 3 }" @click="onCateFilter(3); showCatePopup = false">后台加款</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: accountCateType === 4 }" @click="onCateFilter(4); showCatePopup = false">后台扣款</div>
          <div class="popup-btn" :class="{ active: accountCateType === 5 }" @click="onCateFilter(5); showCatePopup = false">红包</div>
        </div>
      </div>

      <!-- 明细列表 -->
      <div class="detail-list" v-if="accountList.length > 0">
        <div class="detail-item" v-for="(item, idx) in accountList" :key="idx">
          <div class="detail-item-left">
            <div class="detail-order-row">
              <span class="detail-order">{{ item.order_no }}</span>
            </div>
            <div class="detail-info-row">
              <span class="detail-api">{{ item.api_type }}</span>
              <span class="detail-type">{{ item.type_name }}</span>
            </div>
            <div class="detail-time-row">
              <span class="detail-time">{{ item.created_at }}</span>
            </div>
          </div>
          <div class="detail-item-right">
            <span class="detail-money" :class="{ green: item.money > 0, red: item.money < 0 }">{{ item.money > 0 ? '+' : '' }}{{ item.money }}</span>
            <span class="detail-state">{{ item.state_name }}</span>
          </div>
        </div>
      </div>

      <!-- 加载更多 -->
      <div class="load-more" v-if="accountList.length > 0 && accountPage < accountLastPage" @click="loadMore">
        <span>加载更多</span>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-else>
        <img src="/static/image/mescroll-empty.png" class="empty-img" />
        <p class="empty-text">今日暂无记录，可<span class="empty-link">查看更多</span></p>
      </div>

      <!-- 底部统计 -->
      <div class="bottom-stats">
        <div class="stats-grid">
          <div class="stats-cell">
            <span class="stats-label">累计充值</span>
            <span class="stats-value green">{{ accountStats.total_recharge }}</span>
          </div>
          <div class="stats-cell">
            <span class="stats-label">累计提现</span>
            <span class="stats-value red">{{ accountStats.total_withdraw }}</span>
          </div>
          <div class="stats-cell">
            <span class="stats-label">累计领取</span>
            <span class="stats-value yellow">{{ accountStats.total_redpacket }}</span>
          </div>
          <div class="stats-cell"></div>
        </div>
      </div>
    </div>

    <!-- 投注记录 -->
    <div class="tab-content" v-if="reportCurrent === 2">
      <div class="filter-row scroll-filter">
        <div class="filter-item" @click="toggleBetPopup('date')">
          <span>{{ betDateName[betDate] }}</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" :stroke="betPopup === 'date' ? '#d1ae52' : '#999'" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <div class="filter-item" @click="toggleBetPopup('status')">
          <span>{{ betStatus === '' ? '全部状态' : betStatusMap[betStatus] }}</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" :stroke="betPopup === 'status' ? '#d1ae52' : '#999'" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <div class="filter-item" @click="toggleBetPopup('type')">
          <span>{{ betGameTypeLabel }}</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" :stroke="betPopup === 'type' ? '#d1ae52' : '#999'" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <!-- 全部平台筛选（暂时注释）
        <div class="filter-item" @click="toggleBetPopup('platform')">
          <span>{{ betApiTypeName }}</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" :stroke="betPopup === 'platform' ? '#d1ae52' : '#999'" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        -->
      </div>

      <!-- 日期筛选弹窗 -->
      <div class="filter-popup" v-if="betPopup === 'date'">
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betDate === 1 }" @click="onBetDate(1)">今日</div>
          <div class="popup-btn" :class="{ active: betDate === 2 }" @click="onBetDate(2)">近7日</div>
          <div class="popup-btn" :class="{ active: betDate === 3 }" @click="onBetDate(3)">近15日</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betDate === 4 }" @click="onBetDate(4)">近30日</div>
          <div class="popup-btn" :class="{ active: betDate === 0 }" @click="onBetDate(0)">全部</div>
        </div>
      </div>

      <!-- 状态筛选弹窗 -->
      <div class="filter-popup" v-if="betPopup === 'status'">
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betStatus === '' }" @click="onBetStatus('')">全部</div>
          <div class="popup-btn" :class="{ active: betStatus === 1 }" @click="onBetStatus(1)">已结算</div>
          <div class="popup-btn" :class="{ active: betStatus === 2 }" @click="onBetStatus(2)">未结算</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betStatus === 0 }" @click="onBetStatus(0)">无效注单</div>
        </div>
      </div>

      <!-- 类型筛选弹窗 -->
      <div class="filter-popup" v-if="betPopup === 'type'">
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betGameType === '' }" @click="onBetGameType('')">全部</div>
          <div class="popup-btn" :class="{ active: betGameType === 1 }" @click="onBetGameType(1)">真人</div>
          <div class="popup-btn" :class="{ active: betGameType === 3 }" @click="onBetGameType(3)">电子</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betGameType === 2 }" @click="onBetGameType(2)">捕鱼</div>
          <div class="popup-btn" :class="{ active: betGameType === 6 }" @click="onBetGameType(6)">棋牌</div>
          <div class="popup-btn" :class="{ active: betGameType === 5 }" @click="onBetGameType(5)">体育</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betGameType === 4 }" @click="onBetGameType(4)">彩票</div>
          <div class="popup-btn" :class="{ active: betGameType === 7 }" @click="onBetGameType(7)">电竞</div>
        </div>
      </div>

      <!-- 平台筛选弹窗（暂时注释）
      <div class="filter-popup" v-if="betPopup === 'platform'">
        <div class="popup-row">
          <div class="popup-btn" :class="{ active: betApiType === '' }" @click="onBetPlatform('', '全部平台')">全部平台</div>
        </div>
        <div class="popup-row">
          <div class="popup-btn" v-for="(p, i) in betPlatforms" :key="i" :class="{ active: betApiType === p.platname }" @click="onBetPlatform(p.platname, p.name)">{{ p.name }}</div>
        </div>
      </div>
      -->

      <!-- 下注记录列表 -->
      <div class="detail-list" v-if="betList.length > 0">
        <div class="detail-item" v-for="(item, idx) in betList" :key="idx">
          <div class="detail-item-left">
            <div class="detail-order-row">
              <span class="detail-order">{{ item.bet_id }}</span>
            </div>
            <div class="detail-info-row">
              <span class="detail-api">{{ item.Code }}</span>
              <span class="detail-type">投注 {{ item.bet_amount }}</span>
            </div>
            <div class="detail-time-row">
              <span class="detail-time">{{ item.bet_time }}</span>
            </div>
          </div>
          <div class="detail-item-right">
            <span class="detail-money" :class="{ green: item.win_loss > 0, red: item.win_loss < 0 }">{{ item.win_loss > 0 ? '+' : '' }}{{ item.win_loss }}</span>
            <span class="detail-state">{{ betStatusName(item.status) }}</span>
          </div>
        </div>
      </div>

      <!-- 加载更多 -->
      <div class="load-more" v-if="betList.length > 0 && betPage < betLastPage" @click="loadMoreBet">
        <span>加载更多</span>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-if="betList.length === 0 && !betLoading">
        <img src="/static/image/mescroll-empty.png" class="empty-img" />
        <p class="empty-text">暂无记录</p>
      </div>
    </div>

    <!-- 个人报表 -->
    <div class="tab-content" v-if="reportCurrent === 3">
      <div class="report-stats-grid">
        <div class="report-stat">
          <span class="report-stat-label">累计输赢</span>
          <span class="report-stat-value red">0.00</span>
        </div>
        <div class="report-stat">
          <span class="report-stat-label">累计投注金额</span>
          <span class="report-stat-value">0.00</span>
        </div>
        <div class="report-stat">
          <span class="report-stat-label">累计有效投注</span>
          <span class="report-stat-value">0.00</span>
        </div>
        <div class="report-stat">
          <span class="report-stat-label">累计注单量</span>
          <span class="report-stat-value">0</span>
        </div>
      </div>

      <div class="filter-sort-row">
        <div class="filter-item">
          <span>今日</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" stroke="#999" stroke-width="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </div>
        <div class="sort-item">
          <span>输赢排序</span>
          <svg viewBox="0 0 24 24" width="0.25rem" height="0.25rem" fill="none" stroke="#999" stroke-width="2">
            <path d="M12 5v14M5 12l7 7 7-7"/>
          </svg>
        </div>
      </div>

      <div class="empty-state">
        <img src="/static/image/mescroll-empty.png" class="empty-img" />
        <p class="empty-text">今日暂无记录，可<span class="empty-link">查看更多</span></p>
      </div>
    </div>

    <!-- 找回余额 -->
    <div class="tab-content" v-if="reportCurrent === 4">
      <div class="recover-card">
        <div class="recover-row">
          <div class="recover-left">
            <span class="recover-label">当前余额</span>
            <span class="recover-num">{{ $store.state.userInfo.balance }}</span>
            <svg class="refresh-icon" @click="refreshBalance" viewBox="0 0 24 24" width="0.45rem" height="0.45rem" fill="none" stroke="#d1ae52" stroke-width="3">
              <path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
            </svg>
          </div>
          <div class="recover-btn-group">
            <div class="recover-btn transfer-btn" @click="$router.push('/transfer')">转账</div>
            <div class="recover-btn" @click="transall">一键找回</div>
          </div>
        </div>
        <div class="recover-tip">
          只能找回余额的整数倍(即不含小数点)，若仍无法自助找回，请<span class="kefu-link">联系客服</span>处理。
        </div>
      </div>
      
      <!--这里新增div-->
      <div class="game-layout">
        <!-- 左侧分类选项卡 -->
        <div class="game-sidebar">
          <div
            v-for="(cat, idx) in categories"
            :key="idx"
            class="sidebar-item"
            :class="{ active: activeCategory === idx }"
            @click="activeCategory = idx; categorySearch = ''"
          >
            <img v-if="activeCategory === idx" src="/static/newImg/report/xuanzhong_left.avif" class="sidebar-deco sidebar-deco-left" />
            <img :src="activeCategory === idx ? cat.iconActive : cat.icon" class="sidebar-icon" />
            <span class="sidebar-name">{{ cat.name }}</span>
            <img v-if="activeCategory === idx" src="/static/newImg/report/xuanzhong_right.avif" class="sidebar-deco sidebar-deco-right" />
          </div>
        </div>

        <!-- 右侧内容区 -->
        <div class="game-content">
          <!-- 搜索框（仅全部时显示） -->
          <div class="game-search" v-if="activeCategory === 0">
            <input type="text" class="search-input" v-model="categorySearch" placeholder="搜索游戏" />
            <svg class="search-icon-svg" viewBox="0 0 24 24" width="0.4rem" height="0.4rem" fill="none" stroke="#d1ae52" stroke-width="2">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
          </div>

          <!-- 游戏列表（两列） -->
          <div class="game-grid">
            <div class="game-card" v-for="(item, index) in venueList" :key="index">
              <div class="game-card-top">
                <img :src="item.api_logo_img || '/static/image/qianbao123.png'" class="game-card-icon" />
                <span class="game-card-name">{{ item.name }}</span>
              </div>
              <div class="game-card-amount">{{ item.balance }}</div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'Report',
  data() {
    return {
      tabs: ['账户明细', '投注记录', '个人报表', '找回余额'],
      reportCurrent: 1,
      activeCategory: 0,
      categorySearch: '',
      balancelist: [],
      // 账户明细
      accountList: [],
      accountDateType: 'all',
      accountCateType: '',
      accountStats: { total_recharge: '0.00', total_withdraw: '0.00', total_redpacket: '0.00' },
      accountPage: 1,
      accountTotal: 0,
      accountLastPage: 1,
      accountLoading: false,
      showDatePopup: false,
      showCatePopup: false,
      // 投注记录（下注记录）
      betList: [],
      betPage: 1,
      betLastPage: 1,
      betLoading: false,
      betPopup: '',          // 当前打开的筛选弹窗：date/status/type/platform
      betDate: 0,            // 日期：0全部(默认) 1今日 2近7日 3近15日 4近30日
      betDateName: { 0: '全部', 1: '今日', 2: '近7日', 3: '近15日', 4: '近30日' },
      betStatus: '',         // 状态：''全部 0无效 1已结算 2未结算
      betStatusMap: ['无效注单', '已结算', '未结算'],
      betGameType: '',       // 类型：''全部 1真人 2捕鱼 3电子 4彩票 5体育 6棋牌 7电竞
      betGameTypeMap: { 1: '真人', 2: '捕鱼', 3: '电子', 4: '彩票', 5: '体育', 6: '棋牌', 7: '电竞' },
      betApiType: '',        // 平台：空=全部平台（platform_type）
      betApiTypeName: '全部平台',
      betPlatforms: [],      // 平台列表（来自 /api/balancelist）
      // categories 索引 -> 后端 category_id 字符串映射
      // 0:全部 1:电子gaming 2:棋牌concise 3:捕鱼joker 4:真人realbet 5:区块链blockchain 6:体育sport 7:彩票lottery
      categoryIdMap: ['', 'gaming', 'concise', 'joker', 'realbet', 'blockchain', 'sport', 'lottery'],
      categories: [
        { name: '全部', icon: '/static/newImg/report/icon_dtfl_zh_0.svg', iconActive: '/static/newImg/report/icon_dtfl_zh_1.svg' },
        { name: '电子', icon: '/static/newImg/report/icon_dtfl_dz_0.svg', iconActive: '/static/newImg/report/icon_dtfl_dz_1.svg' },
        { name: '棋牌', icon: '/static/newImg/report/icon_dtfl_qp_0.svg', iconActive: '/static/newImg/report/icon_dtfl_qp_1.svg' },
        { name: '捕鱼', icon: '/static/newImg/report/icon_dtfl_by_0.svg', iconActive: '/static/newImg/report/icon_dtfl_by_1.svg' },
        { name: '真人', icon: '/static/newImg/report/icon_dtfl_zr_0.svg', iconActive: '/static/newImg/report/icon_dtfl_zr_1.svg' },
        { name: '区块链', icon: '/static/newImg/report/icon_dtfl_qkl_0.svg', iconActive: '/static/newImg/report/icon_dtfl_qkl_1.svg' },
        { name: '体育', icon: '/static/newImg/report/icon_dtfl_ty_0.svg', iconActive: '/static/newImg/report/icon_dtfl_ty_1.svg' },
        { name: '彩票', icon: '/static/newImg/report/icon_dtfl_cp_0.svg', iconActive: '/static/newImg/report/icon_dtfl_cp_1.svg' },
      ],
    }
  },
  computed: {
    venueList() {
      let list = this.balancelist;
      // 分类筛选：activeCategory=0(全部)不过滤，其余按 categoryIdMap 匹配 category_id
      const catId = this.categoryIdMap[this.activeCategory];
      if (catId) {
        list = list.filter(v => (v.category_id || '') === catId);
      }
      if (this.categorySearch) {
        list = list.filter(v => (v.name || '').includes(this.categorySearch));
      }
      return list;
    },
    betGameTypeLabel() {
      return this.betGameType === '' ? '全部类型' : (this.betGameTypeMap[this.betGameType] || '全部类型');
    }
  },
  created() {
    if (this.$route.query.reportCurrent) {
      this.reportCurrent = parseInt(this.$route.query.reportCurrent);
    }
    if (this.reportCurrent === 1) {
      this.getAccountDetail();
    }
    if (this.reportCurrent === 2) {
      // this.getBetPlatforms();  // 全部平台筛选已注释，暂不请求平台列表
      this.getBetRecord();
    }
    if (this.reportCurrent === 4) {
      this.getbalancelist();
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      // 距离底部 100px 内触发
      if (scrollTop + windowHeight < pageHeight - 100) return;

      // 账户明细选项卡
      if (this.reportCurrent === 1) {
        if (this.accountLoading || this.accountPage >= this.accountLastPage) return;
        this.accountLoading = true;
        this.loadMore();
      }
      // 投注记录选项卡
      if (this.reportCurrent === 2) {
        if (this.betLoading || this.betPage >= this.betLastPage) return;
        this.betLoading = true;
        this.loadMoreBet();
      }
    },
    switchTab(idx) {
      this.reportCurrent = idx;
      this.betPopup = '';
      this.$router.replace({ path: '/report', query: { reportCurrent: idx } });
      if (idx === 1) {
        this.accountPage = 1;
        this.getAccountDetail();
      }
      if (idx === 2) {
        this.betPage = 1;
        // this.getBetPlatforms();  // 全部平台筛选已注释，暂不请求平台列表
        this.getBetRecord();
      }
      if (idx === 4) {
        this.getbalancelist();
      }
    },
    refreshBalance() {
      this.refreshusermoney();
      this.getbalancelist();
    },
    getAccountDetail(loadMore) {
      let that = this;
      if (!loadMore) that.showLoading();
      that.$apiFun
        .post('/api/accountdetail_new', {
          date_type: that.accountDateType,
          cate_type: that.accountCateType,
          page: that.accountPage,
          page_size: 10,
        })
        .then(res => {
          that.hideLoading();
          console.log('accountdetail_new response:', res);
          that.accountLoading = false;
          if (res.code === 200) {
            if (loadMore) {
              that.accountList = that.accountList.concat(res.data.data || []);
            } else {
              that.accountList = res.data.data || [];
            }
            that.accountTotal = res.data.total || 0;
            that.accountLastPage = res.data.last_page || 1;
            // 更新统计数据
            if (res.data.stats) {
              that.accountStats = res.data.stats;
            }
          } else {
            that.showTost(0, res.message);
          }
        })
        .catch(err => {
          that.hideLoading();
          that.accountLoading = false;
          console.error('accountdetail_new error:', err);
        });
    },
    loadMore() {
      this.accountPage++;
      this.getAccountDetail(true);
    },
    // 获取下注记录（投注记录选项卡）
    getBetRecord(loadMore) {
      let that = this;
      if (!loadMore) that.showLoading();
      that.$apiFun
        .post('/api/betrecord', {
          date: that.betDate,
          page: that.betPage,
          api_type: that.betApiType,
          status: that.betStatus,
          game_type: that.betGameType,
          pagesize: 10,
        })
        .then(res => {
          that.hideLoading();
          that.betLoading = false;
          if (res.code === 200) {
            if (loadMore) {
              that.betList = that.betList.concat(res.data.data || []);
            } else {
              that.betList = res.data.data || [];
            }
            that.betLastPage = res.data.last_page || 1;
          } else {
            that.showTost(0, res.message);
          }
        })
        .catch(err => {
          that.hideLoading();
          that.betLoading = false;
          console.error('betrecord error:', err);
        });
    },
    loadMoreBet() {
      this.betPage++;
      this.getBetRecord(true);
    },
    betStatusName(status) {
      return this.betStatusMap[status] || '未结算';
    },
    // 获取平台列表（用于平台筛选）
    getBetPlatforms() {
      let that = this;
      that.$apiFun.post('/api/balancelist', {}).then(res => {
        if (res.code === 200) {
          that.betPlatforms = res.data || [];
        }
      });
    },
    // 打开/关闭筛选弹窗
    toggleBetPopup(type) {
      this.betPopup = this.betPopup === type ? '' : type;
    },
    resetBetList() {
      this.betPage = 1;
      this.betList = [];
      this.betPopup = '';
      this.getBetRecord();
    },
    onBetDate(val) {
      this.betDate = val;
      this.resetBetList();
    },
    onBetStatus(val) {
      this.betStatus = val;
      this.resetBetList();
    },
    onBetGameType(val) {
      this.betGameType = val;
      this.resetBetList();
    },
    onBetPlatform(platname, name) {
      this.betApiType = platname;
      this.betApiTypeName = name || '全部平台';
      this.resetBetList();
    },
    onDateFilter(type) {
      this.accountDateType = type;
      this.accountPage = 1;
      this.getAccountDetail();
    },
    onCateFilter(type) {
      // 切换大类：空=全部 0=转入转出 3=后台加款 4=后台扣款 5=红包
      this.accountCateType = type;
      this.accountPage = 1;
      this.getAccountDetail();
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getbalancelist() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code === 200) {
            that.balancelist = res.data || [];
          } else {
            that.showTost(0, res.message);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    showLoading() {
      if (this.$parent && this.$parent.showLoading) {
        this.$parent.showLoading();
      }
    },
    hideLoading() {
      if (this.$parent && this.$parent.hideLoading) {
        this.$parent.hideLoading();
      }
    },
    showTost(type, title) {
      if (this.$parent && this.$parent.showTost) {
        this.$parent.showTost(type, title);
        return;
      }
      let target = this.$parent;
      while (target) {
        if (target.showTost) {
          target.showTost(type, title);
          return;
        }
        target = target.$parent;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.report-page {
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.3rem;
  background: #0a0a0a;

  .header-back {
    position: absolute;
    left: 0.3rem;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .header-title {
    font-size: 0.4rem;
    font-weight: normal;
    color: #fff;
  }
}

.report-tabs {
  background: #1a1a1a;
  border-bottom: 1px solid #2a2a2a;

  .tabs-wrap {
    display: flex;
    padding: 0 0.3rem;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 0.3rem 0;
      font-size: 0.32rem;
      color: #999;
      position: relative;
      cursor: pointer;

      &.active {
        color: #d1ae52;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0.6rem;
          height: 0.06rem;
          background: #d1ae52;
          border-radius: 0.03rem;
        }
      }
    }
  }
}

.tab-content {
  padding: 0.3rem;
}

/* 账户明细 */
.balance-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem;
  background: #1a1a1a;
  border-radius: 0.2rem;
  margin-bottom: 0.2rem;

  .balance-left {
    display: flex;
    align-items: center;
    gap: 0.15rem;

    .balance-label {
      font-size: 0.32rem;
      color: #999;
    }

    .balance-num {
      font-size: 0.4rem;
      font-weight: bold;
      color: #ffaa09;
    }

    .refresh-icon {
      cursor: pointer;
    }
  }

  .balance-right {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    font-size: 0.3rem;
    color: #d1ae52;
    cursor: pointer;
  }
}

.balance-tip {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.2rem 0.3rem;
  background: #1a1a1a;
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;

  span {
    font-size: 0.28rem;
    color: #999;
  }
}

/* 筛选 */
.filter-row {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.3rem;

  &.scroll-filter {
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  .filter-item {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    padding: 0.15rem 0.3rem;
    background: #1a1a1a;
    border: 1px solid #333;
    border-radius: 0.5rem;
    font-size: 0.28rem;
    color: #999;
    white-space: nowrap;
    cursor: pointer;
  }
}

/* 筛选弹窗 */
.filter-popup {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 0.1rem;
  padding: 0.15rem;
  margin-bottom: 0.3rem;

  .popup-row {
    display: flex;
    gap: 0.15rem;
    margin-bottom: 0.15rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .popup-btn {
    flex: 1;
    text-align: center;
    padding: 0.15rem 0;
    font-size: 0.28rem;
    color: #999;
    background: #222;
    border-radius: 0.08rem;
    cursor: pointer;

    &.active {
      background: #d1ae52;
      color: #000;
    }
  }
}

/* 明细列表 */
.detail-list {
  padding: 0;
  margin-bottom: 2rem;

  .detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #1a1a1a;
    padding: 0.2rem 0.3rem;
    margin-bottom: 0.2rem;
    border-bottom: none;

    .detail-item-left {
      display: flex;
      flex-direction: column;
      gap: 0.15rem;

      .detail-order-row {
        .detail-order {
          padding: 0.2rem 0;
          font-size: .35rem;
          color: #999;
          letter-spacing: 0.02rem;
        }
      }

      .detail-info-row {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        letter-spacing: 0.05rem;

        .detail-api {
          font-size: 0.28rem;
          color: #d1ae52;
          background: rgba(209, 174, 82, 0.15);
          padding: 0.03rem 0.12rem;
          border-radius: 0.04rem;
        }

        .detail-type {
          font-size: 0.28rem;
          color: #fff;
        }
      }

      .detail-time-row {
        .detail-time {
          font-size: 0.24rem;
          color: #666;
          letter-spacing: 0.03rem;
        }
      }
    }

    .detail-item-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 0.08rem;

      .detail-money {
        font-size: 0.32rem;
        font-weight: bold;

        &.green {
          color: #3c3;
        }

        &.red {
          color: #ff6034;
        }
      }

      .detail-state {
        font-size: 0.28rem;
        color: #999;
      }
    }
  }
}

/* 加载更多 */
.load-more {
  text-align: center;
  padding: 0.2rem 0;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  color: #d1ae52;
  cursor: pointer;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;

  .empty-img {
    width: 3rem;
    height: 3rem;
    opacity: 0.5;
  }

  .empty-text {
    font-size: 0.3rem;
    color: #666;
    margin-top: 0.3rem;

    .empty-link {
      color: #d1ae52;
      cursor: pointer;
    }
  }
}

/* 找回余额卡片 */
.recover-card {
    background: #1a1a1a;
    border-radius: 0.2rem;
    padding: 0.3rem;

    .recover-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.3rem;

      .recover-left {
        display: flex;
        align-items: center;
        gap: 0.15rem;

        .recover-label {
          font-size: 0.32rem;
          color: #999;
        }

        .recover-num {
          font-size: 0.4rem;
          font-weight: bold;
          color: #ffaa09;
        }

        .refresh-icon {
          cursor: pointer;
        }
      }

      .recover-btn-group {
        display: flex;
        align-items: center;
        gap: 0.15rem;
      }

      .recover-btn {
        padding: 0.15rem 0.4rem;
        background: #d1ae52;
        color: #000;
        font-size: 0.28rem;
        border-radius: 0.1rem;
        cursor: pointer;
        white-space: nowrap;
        flex-shrink: 0;

        &.transfer-btn {
          background: #ff6b35;
          color: #fff;
          margin: 0;
          padding: 0.15rem 0.4rem;
        }
      }
    }

  .recover-tip {
    font-size: 0.28rem;
    color: #999;
    line-height: 1.5;

    .kefu-link {
      color: #d1ae52;
      cursor: pointer;
    }
  }
}

/* 底部统计 */
.bottom-stats {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #1a1a1a;
  padding: 0.3rem;
  border-top: 1px solid #2a2a2a;

  .stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.3rem 1rem;
  }

  .stats-cell {
    display: flex;
    align-items: center;
    gap: 0.8rem;

    .stats-label {
      font-size: 0.28rem;
      color: #999;
    }

    .stats-value {
      font-size: 0.32rem;
      font-weight: normal;

      &.green {
        color: #00e676;
      }

      &.red {
        color: #ff5252;
      }

      &.yellow {
        color: #ffaa09;
      }
    }
  }
}

/* 个人报表统计网格 */
.report-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.3rem;
  margin-bottom: 0.3rem;

  .report-stat {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;

    .report-stat-label {
      font-size: 0.28rem;
      color: #999;
    }

    .report-stat-value {
      font-size: 0.35rem;
      font-weight: bold;
      color: #fff;

      &.red {
        color: #ff5252;
      }
    }
  }
}

/* 筛选排序行 */
.filter-sort-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;

  .filter-item {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    padding: 0.15rem 0.3rem;
    background: #1a1a1a;
    border: 1px solid #333;
    border-radius: 0.5rem;
    font-size: 0.28rem;
    color: #999;
    cursor: pointer;
  }

  .sort-item {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    font-size: 0.28rem;
    color: #999;
    cursor: pointer;
  }
}

/* 游戏布局 */
.game-layout {
  display: flex;
  gap: 0.3rem;
  margin-top: 0.3rem;

  .game-sidebar {
    flex: 0 0 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    .sidebar-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.1rem;
      padding: 0.15rem 0.2rem;
      background: #1a1a1a;
      border-radius: 0.15rem;
      cursor: pointer;
      transition: all 0.2s;
      position: relative;

      &.active {
        background: url('/static/newImg/report/xuanzhong_bg.avif') center/contain no-repeat;
      }

      .sidebar-deco {
        position: absolute;
        width: 0.65rem;
        height: 0.65rem;
        flex-shrink: 0;
        z-index: 1;
      }

      .sidebar-deco-left {
        top: 0;
        left: 0.1rem;
      }

      .sidebar-deco-right {
        bottom: 0;
        right: 0.1rem;
      }

      .sidebar-icon {
        width: 0.6rem;
        height: 0.6rem;
      }

      .sidebar-name {
        font-size: 0.35rem;
        color: #999;
        white-space: nowrap;
      }

      &.active .sidebar-name {
        color: #d1ae52;
      }
    }
  }

  .game-content {
    flex: 1;
    min-width: 0;

    .game-search {
      display: flex;
      align-items: center;
      background: #1a1a1a;
      border: 1px solid #333;
      border-radius: 0.5rem;
      padding: 0.15rem 0.3rem;
      margin-bottom: 0.3rem;

      .search-input {
        flex: 1;
        background: transparent;
        border: none;
        outline: none;
        color: #fff;
        font-size: 0.3rem;

        &::placeholder {
          color: #666;
        }
      }

      .search-icon-svg {
        flex-shrink: 0;
        margin-left: 0.2rem;
      }
    }

    .game-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.2rem;

      .game-card {
        background: #1a1a1a;
        border-radius: 0.15rem;
        padding: 0.2rem;

        .game-card-top {
          display: flex;
          align-items: center;
          gap: 0.15rem;
          margin-bottom: 0.15rem;
          padding-bottom: 0.15rem;
          border-bottom: 1px solid #333333;

          .game-card-icon {
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 0.1rem;
            object-fit: cover;
          }

          .game-card-name {
            font-size: 0.28rem;
            color: #fff;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .game-card-amount {
          font-size: 0.3rem;
          font-weight: bold;
          color: #666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/report/report.vue